module.exports = __webpack_public_path__ + "img/convergists1.2b38bdfe.png";